import { useCallback } from 'react'
import { gql } from '@apollo/client'
import { useTranslations } from '@npco/utils-translations'
import { ButtonFill } from '@npco/zeller-design-system'
import { useFeatureFlags } from 'features/FeatureFlags'

import { useGoToAddCardStage } from 'hooks/useGoToAddCardStage/useGoToAddCardStage'
import { AddCardStage } from 'hooks/useGoToAddCardStage/useGoToAddCardStage.types'
import { translationsShared } from 'translations'

import { useGoToBlockedAction } from '../../../../../../BlockedAction/blocked-action-routing'
import { AddCardButtonEntityFragment } from './AddCardButton.generated'

interface AddCardButtonProps {
  entity?: AddCardButtonEntityFragment
}

export const AddCardButton = ({ entity }: AddCardButtonProps) => {
  const tShared = useTranslations(translationsShared)
  const { goToAddCardStage } = useGoToAddCardStage()
  const { goToBlockedAction } = useGoToBlockedAction()

  const flags = useFeatureFlags()
  const handleAddCard = useCallback(() => {
    if (flags.AmsFlags && entity && !entity.canCreateCard) {
      goToBlockedAction({ blockedAction: 'createCard' })
      return
    }
    goToAddCardStage({ stage: AddCardStage.LandingPageStage })
  }, [entity, goToAddCardStage, goToBlockedAction, flags.AmsFlags])

  return <ButtonFill onClick={handleAddCard}>{tShared('addCard')}</ButtonFill>
}

AddCardButton.fragments = {
  Entity: gql`
    fragment AddCardButtonEntityFragment on Entity {
      id
      canCreateCard
    }
  `,
}
